import { ProviderInvoiceStateEnum } from "src/app/enum/provider-invoice-state-enum";
import { ProviderModel } from "../archive/provider.model";

export class ProviderInvoiceModel {
  providerInvoiceId: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  enterpriseId: number = 0;
  providerId: number = 0;
  provider: ProviderModel | null = null;
  prefix: string | null = null;
  invoiceNumber: number = 0;
  date: Date = new Date();
  dateExpiration: Date = new Date();
  observation: string | null = null;
  subtotalValue: number = 0;
  ivaValue: number = 0;
  noteDebitValue: number = 0;
  noteCreditValue: number = 0;
  retentionValue: number = 0;
  state: number = ProviderInvoiceStateEnum.open;
  dateAnnull: Date | null = null;
  remisionNumber: string | null = null;
  advanceValue: number = 0;
  swRetentionOk: boolean = false;
  paymentValue: number = 0;
  residueValue: number = 0;
  swPaid: boolean = false;
  ivaTypeId: number = 0;
  retainedValue: number = 0;
  accountingInterfaceId: number | null = null;
  createDate: Date | null = null;
  userNameCreate: string | null = null;
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}
